<script setup>
import { useChatStore } from '../stores/chat';
import ChatMessages from '../components/chats/ChatMessages.vue';
import ChatInput from '../components/chats/ChatInput.vue';

const chatStore = useChatStore();

</script>

<template>
    <!-- AI Section Body -->
    <div class="dataagent-section-body">
      <!-- API Connection Check -->
      <div
        v-if="!chatStore.settings.hasApiKey"
        class="dataagent-ai-connect-prompt da:flex da:items-center da:bg-gray-50 da:px-6 da:pt-2 da:pb-6 da:mb-4"
      >
        <div class="dataagent-ai-connect-icon da:bg-green-100 da:p-3 da:rounded-full da:mr-6">
          <span class="dashicons dashicons-admin-plugins da:text-green-600 da:text-2xl"></span>
        </div>
        <div class="dataagent-ai-connect-message da:flex-1">
          <h3 class="da:text-xl da:font-semibold da:text-gray-800 da:mb-2">
            {{ chatStore.labels.connect_ai }}
          </h3>
          <p class="da:text-gray-600 da:mb-4">
            {{
              chatStore.labels.connect_ai_desc ||
              'Unlock the full potential of your data by connecting to an AI model. Get personalized insights, analysis, and recommendations.'
            }}
          </p>
          <a
            :href="chatStore.settings.settingsUrl"
            class="button-primary da:inline-block da:text-white da:px-5 da:py-2 da:rounded-lg da:transition-colors da:no-underline"
          >
            {{ chatStore.labels.connect_ai_btn }}
          </a>
        </div>
      </div>

      <!-- Chat Interface (only show if API key is configured) -->
      <div class="dataagent-ai-chatbox da:bg-gray-50 da:overflow-hidden">
        <!-- Chat Messages -->
        <ChatMessages />

        <!-- Chat Input -->
        <ChatInput />
      </div>
    </div>
</template>